<script>
import ModalBus from '@/eventBus'

export default {
  name: 'SuccessQuoteForm',

  methods: {
    closePopup() {
      ModalBus.emit('close')
    },
  },
}
</script>

<template>
  <div class="w-11/12 rounded-xl bg-white">
    <div class="flex items-center justify-between border-b-2 border-light/25 p-5">
      <span class="max-w-10/12 font-poppins text-xl font-medium lg:text-secondary">
        {{ $t('vehicles.quoteFormSuccess.title') }}
      </span>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <div class="p-5">
      <div class="flex w-full items-start rounded-xl border border-primary px-2 py-4">
        <svg
          class="mr-4 h-auto w-8"
          fill="none"
          height="33"
          stroke="#469752"
          viewBox="0 0 24 24"
          width="34"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 13l4 4L19 7"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2" />
        </svg>
        <p class="font-sans text-sm font-bold text-primary">
          {{ $t('vehicles.quoteFormSuccess.description') }}
        </p>
      </div>
      <div class="mt-8 flex w-full flex-col">
        <a
          class="btn mb-4 w-full"
          href="/"
          >{{ $t('buttons.backToIndex') }}</a
        >
        <a
          class="btn w-full border border-secondary bg-white text-secondary"
          href="/activites">
          {{ $t('buttons.activities') }}
        </a>
      </div>
    </div>
  </div>
</template>
